import React from 'react';

import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

function CloseButton({ className = '', onClick = () => {} }) {
  return (
    <button
      type="button"
      tabIndex={0}
      onClick={onClick}
      className={className}
      title="Stäng"
      aria-label="stäng knapp"
    />
  );
}

CloseButton.propTypes = propTypes;

export default CloseButton;
